module.exports = __webpack_public_path__ + "static/pch-77647188cee146b7790d5053abbbe07f.svg";